import React, { lazy } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface Brand {
  name: string;
  logo: string;
}
export function BrandBanner() {
  const brands: Brand[] = [{
    name: 'Subto',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/umanX5dLdFbeAwfQrapxe1/Screenshot_2025-11-15_at_12.47.47_PM.png'
  }, {
    name: 'Section 8 Secrets',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rggg1dpYqcEi3Gc8jvXWfW/Screenshot_2025-11-15_at_12.48.11_PM.png'
  }, {
    name: 'Investorlift',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/aMekGdbYKAsSFjLcbLW7oA/Screenshot_2025-11-15_at_12.47.39_PM.png'
  }, {
    name: 'BatchLeads',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sYNjDxMQwVPg93rbrAWHAw/BatchLeads_Logo.webp'
  }, {
    name: 'Kind Skiptracing',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cpW1uYBe2NbPMBcbpTLTjC/Screenshot_2025-11-15_at_12.49.24_PM.png'
  }];
  const scrollToNextSection = () => {
    const heroSection = document.querySelector('[data-section="hero"]');
    if (heroSection) {
      const nextSection = heroSection.nextElementSibling;
      if (nextSection) {
        nextSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };
  return <div className="w-full py-8 sm:py-12 overflow-hidden" data-id="element-1483">
      <div className="relative z-10" data-id="element-1484">
        {/* Trust text - improved copy with specific numbers */}
        <div className="text-center mb-8" data-id="element-1485">
          <p className="text-xs sm:text-sm font-semibold text-[#3ab795] uppercase tracking-wider mb-2" data-id="element-1486">
            Powering Offers For Industry Leaders
          </p>
          <p className="text-sm sm:text-base text-white/70" data-id="element-1487">
            Built for serious real estate investors
          </p>
        </div>

        {/* Logo scroll container */}
        <div className="relative flex items-center overflow-hidden" data-id="element-1488">
          {/* Enhanced fade edges */}
          <div className="absolute left-0 top-0 bottom-0 w-24 sm:w-40 bg-gradient-to-r from-[#070707] via-[#070707]/80 to-transparent z-20 pointer-events-none" data-id="element-1489" />
          <div className="absolute right-0 top-0 bottom-0 w-24 sm:w-40 bg-gradient-to-l from-[#070707] via-[#070707]/80 to-transparent z-20 pointer-events-none" data-id="element-1490" />

          {/* Scrolling content - SIMPLIFIED CARDS */}
          <div className="flex animate-scroll-brands-smooth gap-8 sm:gap-12 py-6" data-id="element-1491">
            {/* First set of brands */}
            {brands.map((brand, index) => <div key={`brand-1-${index}`} className="flex-shrink-0 group" data-id="element-1492">
                {/* Simplified logo card - minimal background */}
                <div className="relative px-8 py-5 rounded-xl bg-white/5 border border-white/10 backdrop-blur-sm transition-all duration-300 hover:bg-white/10" data-id="element-1493">
                  {/* Logo image - full color, brightness boost on hover */}
                  <img src={brand.logo} alt={brand.name} className="relative h-8 sm:h-10 w-auto object-contain opacity-70 group-hover:opacity-100 group-hover:brightness-110 transition-all duration-300 mix-blend-lighten" loading="lazy" data-id="element-1494" />
                </div>
              </div>)}

            {/* Duplicate set for seamless loop */}
            {brands.map((brand, index) => <div key={`brand-2-${index}`} className="flex-shrink-0 group" data-id="element-1495">
                <div className="relative px-8 py-5 rounded-xl bg-white/5 border border-white/10 backdrop-blur-sm transition-all duration-300 hover:bg-white/10" data-id="element-1496">
                  <img src={brand.logo} alt={brand.name} className="relative h-8 sm:h-10 w-auto object-contain opacity-70 group-hover:opacity-100 group-hover:brightness-110 transition-all duration-300 mix-blend-lighten" loading="lazy" data-id="element-1497" />
                </div>
              </div>)}
          </div>
        </div>

        {/* Circular Glassmorphism Scroll Button */}
        <div className="flex justify-center mt-14 animate-fade-in" data-id="element-1498">
          <button onClick={scrollToNextSection} className="group relative w-16 h-16 sm:w-18 sm:h-18 rounded-full bg-gradient-to-br from-[#2a2a2a]/80 to-[#1a1a1a]/80 border-2 border-white/30 backdrop-blur-md transition-all duration-500 hover:border-[#3ab795] hover:bg-[#2a2a2a] hover:shadow-[0_12px_40px_rgba(58,183,149,0.4)] hover:scale-110 animate-float focus:outline-none focus-visible:ring-2 focus-visible:ring-[#3ab795] focus-visible:ring-offset-2 focus-visible:ring-offset-[#070707]" aria-label="Scroll down to next section" data-id="element-1499">
            {/* Enhanced glow effect on hover */}
            <div className="absolute inset-0 rounded-full bg-gradient-to-br from-[#3ab795]/0 to-[#3ab795]/0 group-hover:from-[#3ab795]/20 group-hover:to-[#3ab795]/30 transition-all duration-500 pointer-events-none" data-id="element-1500" />

            {/* Chevron Icon with Bounce Animation */}
            <div className="absolute inset-0 flex items-center justify-center animate-bounce-down" data-id="element-1501">
              <ChevronDownIcon className="w-7 h-7 sm:w-8 sm:h-8 text-white/90 group-hover:text-[#3ab795] transition-colors duration-500" strokeWidth={2.5} data-id="element-1502" />
            </div>

            {/* Enhanced pulse ring effect */}
            <div className="absolute inset-0 rounded-full border-2 border-[#3ab795]/0 group-hover:border-[#3ab795]/50 group-hover:animate-pulse-ring transition-all duration-500" data-id="element-1503" />
          </button>
        </div>
      </div>
    </div>;
}